import "./App.css";
import Chat from "./chat/Chat";
import React, { useContext, useEffect, useRef } from "react";
import Sidebar from "./sidebar/Sidebar";
import { GlobalVariablesContext } from "./GlobalVariables";
import Login from "./Login/Login";
import { Routes, Route } from 'react-router-dom';
import CCAvenue from './CCAvenue/CCAvenue';

function App() {
  const { currentUser, setCurrentUser, isLoggedIn2, setisLoggedIn2, setIsMobileSidebarHidden } = useContext(
    GlobalVariablesContext
  );

  // Ref so the popstate handler always sees the latest currentUser (avoids stale closure)
  const currentUserRef = useRef(currentUser);
  useEffect(() => {
    currentUserRef.current = currentUser;
  }, [currentUser]);

  useEffect(() => {
    if (isLoggedIn2 !== "true") return;

    if (window.innerWidth >= 700) {
      // Desktop: block back navigation to prevent page exit
      window.history.pushState(null, null, window.location.href);
      const blockBack = () => window.history.go(1);
      window.addEventListener("popstate", blockBack);
      return () => window.removeEventListener("popstate", blockBack);
    }

    // Mobile PWA back-button lock pattern:
    // Push a "lock" entry so the browser always has something to go back to.
    // In the handler we immediately re-push it, so Android back NEVER exits the browser.
    window.history.pushState({ chatAppLock: true }, "");

    const handlePopState = () => {
      // Re-push the lock entry immediately — this prevents the browser from exiting
      window.history.pushState({ chatAppLock: true }, "");

      // If a chat is open, close it and reveal the sidebar
      if (currentUserRef.current) {
        setIsMobileSidebarHidden(false);
        setCurrentUser(null);
      }
      // If sidebar is already visible (no chat open), do nothing — back is silently absorbed
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [isLoggedIn2, setCurrentUser, setIsMobileSidebarHidden]);

  return (
    <Routes>
      <Route path="/ccavenue-redirect" element={<CCAvenue />} />
      <Route path="*" element={
        <div className="chat">
          <div className="chat__body">
            {isLoggedIn2 === "true" ? (
              <>
                <Sidebar />
                {currentUser && <Chat />}
              </>
            ) : (
              <Login setisLoggedIn2={setisLoggedIn2} />
            )}
          </div>
        </div>
      } />
    </Routes>
  );
}

export default App;
